import { ArrowIcon } from "~/shared/components/icons/ArrowIcon";
import { SpinnerIcon } from "~/shared/components/icons/SpinnerIcon";
import { tw } from "~/utils";
import { FormActionButtonsContainer } from "./FormActionButtonsContainer";

interface ActionButtonsProps {
  onPrev: () => void;
  isNextLoading?: boolean;
  isNextDisabled?: boolean;
  helperText?: string;
}

export const ActionButtons = ({
  onPrev,
  isNextLoading = false,
  isNextDisabled = false,
  helperText,
}: ActionButtonsProps) => {
  return (
    <FormActionButtonsContainer
      className="justify-between"
      helperText={isNextDisabled ? helperText : undefined}
    >
      <button
        type="button"
        onClick={onPrev}
        className="flex cursor-pointer items-center justify-end gap-2 px-6 py-4 font-medium"
      >
        <ArrowIcon direction="right" />
        <span>PREV</span>
      </button>
      {!isNextLoading ? (
        <button
          type="submit"
          disabled={isNextDisabled}
          className={tw(
            "flex items-center justify-end gap-2 px-6 py-4 font-medium transition-all",
            isNextDisabled
              ? "cursor-not-allowed bg-gray-300 text-gray-500"
              : "cursor-pointer bg-green-300",
          )}
        >
          <span>NEXT</span>
          <ArrowIcon direction="left" />
        </button>
      ) : (
        <div className="flex flex-col items-center justify-center bg-green-300 px-6 py-4">
          <SpinnerIcon className="my-auto mr-0 size-5" />
        </div>
      )}
    </FormActionButtonsContainer>
  );
};
